import { useMutation } from '@tanstack/react-query';

import { PluginEquifaxConsumerCreditReportRequest } from '../../../../types/plugins';
import { handleError, handleSuccess } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { runEquifaxApplyConsumerReportRequest } from '../../requests/runEquifaxApplyConsumerReportRequest';

export const useRunEquifaxApplyConsumerReportRequest = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (data: PluginEquifaxConsumerCreditReportRequest) =>
      runEquifaxApplyConsumerReportRequest(constructPost, data),
    onSuccess: () => handleSuccess('Equifax request completed'),
    onError: () => handleError('Equifax request failed'),
  });
  return { runEquifaxApplyConsumerReportRequest: mutateAsync, ...rest };
};
